'use client';

import { faUserMd } from '@fortawesome/pro-solid-svg-icons';
import { hasContent } from 'src/utils/hasContent/hasContent';
import InfoUnavailable from '../InfoUnavailable';
import ProfessionalMixList from './ProfessionalMixList';
import { useProfile } from 'src/context/providers/ProfileProvider';
import { Box, Card, ProfileCardHeader } from 'src/components';

const ProfileProfessionalMix = () => {
  const { entityDetails } = useProfile();
  const mixes = entityDetails?.professional_mix || [];
  return (
    <>
      <Card className="p-6">
        <ProfileCardHeader
          icon={faUserMd}
          title="Healthcare Professional Mix"
          infoTooltip={true}
          tooltipView="centerProfile"
        />
        <Box className="flex flex-col gap-4">
          {hasContent(mixes) ? (
            <ProfessionalMixList professionalMixes={mixes} />
          ) : (
            <InfoUnavailable />
          )}
        </Box>
      </Card>
    </>
  );
};

export default ProfileProfessionalMix;
